import React, { useState, useEffect } from "react";

const MpesaConfirmModal = ({
  isMpesaConfirmModalOpen,
  closeMpesaConfirmModal,
  handleConfirmMpesaBack,
  onDisburse,
  mpesaNumber,
  setMpesaNumber,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      <div
        className={`${
          isMpesaConfirmModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-10 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative bg-white shadow max-w-auto h-[80vh] mx-auto p-6 rounded-sm">
            <div className="flex flex-col h-full">
              <div className="flex justify-end">
                <button
                  onClick={closeMpesaConfirmModal}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  ✕
                </button>
              </div>

              <div className="mt-6">
                <h2 className="text-2xl font-bold text-black mb-4 text-center flex justify-start">
                  Confirm M-PESA Phone Number
                </h2>
                <div className="mb-4">
                  <p className="text-black">
                    Verify the recipient's account details before disbursing
                    funds. Ensure accuracy to prevent errors or delays.
                  </p>
                  <p className="text-black">
                    Check that the Account Name matches with the member’s name.
                    <span className="font-semibold">
                      DO NOT DISBURSE FUNDS IF THE ACCOUNT NAME
                    </span>
                  </p>
                  <p className="text-black">
                    <span className="font-semibold">
                      DOES NOT MATCH WITH THE MEMBER’S NAME.
                    </span>
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex flex-col items-start space-y-2">
                    <label className="text-lg font-semibold text-black">
                      M-PESA Phone Number
                    </label>
                    <div className="flex items-center space-x-4">
                      <input
                        type="text"
                        placeholder="Enter M-PESA Number"
                        value={mpesaNumber}
                        readOnly={true}
                        className="bg-transparent outline-none w-[404px] h-[51px] text-black border bg-[#EAEAEA] rounded-md p-4"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-grow"></div>

              <div className="flex justify-between pb-4">
                <button
                  onClick={handleConfirmMpesaBack}
                  className="bg-[#7FB8EB] text-white w-[243px] h-[51px] px-6 py-3 rounded-lg text-lg"
                >
                  Back
                </button>
                <button
                  onClick={onDisburse}
                  className="bg-[#074073] text-white w-[243px] h-[51px] px-6 py-3 rounded-lg text-lg"
                  disabled={isEditing}
                >
                  Disburse
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MpesaConfirmModal;
